<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Internationaal verhuizen?</h1>
      <p>
        Plant u een internationale verhuizing? Een verhuizing naar een ander
        land is natuurlijk erg spannend. De bij Alleverhuizers.nl aangesloten
        verhuisbedrijven zorgen ervoor dat u gemakkelijk en ontspannen kunt
        verhuizen! Op Alleverhuizers.nl heeft u de mogelijkheid om meerdere
        offertes tegelijk aan te vragen van verschillende internationale
        verhuisbedrijven. Zo bent u binnen de kortste keren in het bezit van
        diverse offertes, kunt u in alle rust de offertes naast elkaar leggen en
        natuurlijk helemaal zelf bekijken bij welk bedrijf internationaal
        verhuizen het best geregeld is. En dat volledig gratis en helemaal
        vrijblijvend!
      </p>

      <h2>Kleine moeite, groot verschil</h2>
      <p>
        Het aanvragen en vergelijken van offertes is niet alleen gratis, maar
        ook snel geregeld. Bovendien zorgen de aangesloten verhuisbedrijven dat
        u zo snel mogelijk de beschikking heeft over de offertes, zodat u ruim
        op tijd alle offertes kunt bestuderen om vervolgens afspraken te maken
        met het bedrijf dat de beste prijs/ kwaliteit garandeert. Vooral als het
        gaat om internationaal verhuizen is het belangrijk goed te kunnen
        vergelijken, het gaat immers over flinke afstanden. Ook is het
        belangrijk om de voorwaarden goed te vergelijken. Hoe zit het
        bijvoorbeeld met de garantie? Wie zich van tevoren goed verdiept in de
        offertes, kan zeker bij een internationale verhuizing zijn voordeel
        doen!
      </p>

      <h2>Internationaal verhuizen, offertes vergelijken</h2>
      <p>
        Vraag vandaag nog kosteloos <nuxt-link to="/"> offertes </nuxt-link> aan
        en ontvang binnen no time offertes van diverse internationale
        verhuisbedrijven! Zo kunt u alle mogelijkheden eens rustig naast elkaar
        leggen en een weloverwogen beslissing nemen. Laat dus snel uw
        persoonlijke gegevens achter, vul de benodigde verhuisinformatie in en
        maak uw verpakkingsvoorwaarden kenbaar. Wij doen de rest en zorgen
        ervoor dat internationaal verhuizen met AlleVerhuizers een feest wordt!
      </p>
      <p>
        Ook voor een
        <nuxt-link to="/informatie-over-verhuizers/particuliere-verhuizingen">
          particuliere verhuizing
        </nuxt-link>
        of
        <nuxt-link to="/informatie-over-verhuizers/zakelijke-verhuizingen">
          zakelijke verhuizing
        </nuxt-link>
        binnen Nederland zit u uiteraard goed op Alleverhuizers.nl.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Internationale Verhuizingen',
      headDescription:
        'Heb je een internationale verhuizing op de agenda staan? Vergelijk gratis meerdere offertes via Alleverhuizers.nl en bespaar tot honderden euro’s!',
    }
  },
}
</script>
